import { gql } from "@apollo/client";

export const LISTING_COMMENTS = gql`
  query GetListingComments(
    $listing_id: Int!
    $last_comment_id: String
    $page_size: Int
  ) {
    ListingComments {
      getListingComments(
        listing_id: $listing_id
        last_comment_id: $last_comment_id
        page_size: $page_size
      ) {
        comments {
          comment_id
          listing_id
          commenter_name
          commenter_img
          created_by
          comment
          created_at
          answer
          answered_at
          answered_by
          answered_by_name
          answered_by_img
          deleted_at
        }
        total
      }
    }
  }
`;
